/*
 * File: abbyCadabbyApi.ts
 * Project: rosita
 * -----
 * Last Modified: 03 Mar 2022 12:22:31 am
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { ApiMultipleResponse } from 'models/ApiModels';
import { ReduxState } from 'redux/store';

const baseUrl = process.env.REACT_APP_LEFTY_THE_SALESMAN_BASE_URL;
const functionsKey = process.env.REACT_APP_API_HOST_KEY_LEFTY_THE_SALESMAN;

interface Employee {
  dataAreaId: string;
  name: string;
  personnelNumber: string;
}

export const leftyTheSalesman = createApi({
  reducerPath: 'leftyTheSalesman',
  baseQuery: fetchBaseQuery({
    baseUrl,
    prepareHeaders: (headers, { getState, endpoint }) => {
      const token = (getState() as ReduxState).app.accessToken;

      if (token) {
        headers.set('authorization', `Bearer ${token}`);
        headers.set('x-functions-key', functionsKey);
      }

      if (endpoint !== 'updateApplicationLogo') headers.set('Content-Type', 'application/json');

      return headers;
    }
  }),
  tagTypes: ['Employees'],
  endpoints: (builder) => ({
    getEmployees: builder.query<ApiMultipleResponse<Employee>, void>({
      query: () => ({
        url: '/employees?dataAreaId=MDSI&overrideSkipTake=true'
      }),
      providesTags: ['Employees']
    }),
    getVersion: builder.query<string, void>({
      query: () => ({
        url: '/diagnostics/version',
        responseHandler: (response): Promise<string> => response.text()
      })
    }),
    getApiName: builder.query<string, void>({
      query: () => ({
        url: '/diagnostics/apiName',
        responseHandler: (response): Promise<string> => response.text()
      })
    })
  })
});

export const { useGetEmployeesQuery } = leftyTheSalesman;
